import { useState, useMemo } from "react";

const allCities = [
  { name: "Aberdeen", tagline: "Moore County expedited passport services", highlights: ["Sandhills area coverage", "Serving Pinehurst, Southern Pines"], badge: null, status: "live", route: "/cities/aberdeen" },
  { name: "Apex", tagline: "Wake County expedited passport processing", highlights: ["Apex area coverage", "Serving Cary, Holly Springs"], badge: null, status: "live", route: "/cities/apex" },
  { name: "Asheboro", tagline: "Randolph County expedited passport services", highlights: ["Asheboro area coverage", "Serving Archdale, Trinity"], badge: null, status: "live", route: "/cities/asheboro" },
  { name: "Asheville", tagline: "Buncombe County expedited passport hub", highlights: ["Blue Ridge Mountain coverage", "Serving Hendersonville, Black Mountain"], badge: null, status: "live", route: "/cities/asheville" },
  { name: "Burlington", tagline: "Alamance County expedited passport services", highlights: ["Burlington area coverage", "Serving Graham, Mebane"], badge: null, status: "live", route: "/burlington" },
  { name: "Cary", tagline: "Wake County expedited passport processing", highlights: ["Cary area coverage", "Serving Apex, Morrisville, Research Triangle"], badge: null, status: "live", route: "/cities/cary" },
  { name: "Chapel Hill", tagline: "Orange County expedited passport services", highlights: ["UNC Chapel Hill area", "Serving Carrboro, Durham"], badge: null, status: "live", route: "/cities/chapel-hill" },
  { name: "Charlotte", tagline: "Mecklenburg County emergency passport services", highlights: ["Uptown & Ballantyne coverage", "Serving Matthews, Mint Hill, Huntersville"], badge: "Most Popular", status: "live", route: "/cities/charlotte" },
  { name: "Clayton", tagline: "Johnston County expedited passport processing", highlights: ["Clayton area coverage", "Serving Garner, Smithfield"], badge: null, status: "live", route: "/cities/clayton" },
  { name: "Concord", tagline: "Cabarrus County expedited passport services", highlights: ["Concord area coverage", "Serving Kannapolis, Harrisburg"], badge: null, status: "live", route: "/cities/concord-nc" },
  { name: "Cornelius", tagline: "Mecklenburg County expedited passport services", highlights: ["Lake Norman area coverage", "Serving Davidson, Huntersville"], badge: null, status: "live", route: "/cities/cornelius" },
  { name: "Davidson", tagline: "Mecklenburg & Iredell County expedited passport services", highlights: ["Davidson College area coverage", "Serving Cornelius, Mooresville"], badge: null, status: "live", route: "/cities/davidson" },
  { name: "Durham", tagline: "Durham County expedited passport hub", highlights: ["Duke University area", "Serving Chapel Hill, Research Triangle"], badge: null, status: "live", route: "/cities/durham" },
  { name: "Fayetteville", tagline: "Cumberland County expedited passport services", highlights: ["Fort Liberty area coverage", "Serving Hope Mills, Spring Lake"], badge: null, status: "live", route: "/cities/fayetteville" },
  { name: "Fuquay-Varina", tagline: "Wake County expedited passport processing", highlights: ["Fuquay-Varina area coverage", "Serving Holly Springs, Angier"], badge: null, status: "live", route: "/cities/fuquay-varina" },
  { name: "Garner", tagline: "Southeast Raleigh & Johnston County expedited passport services", highlights: ["Garner area coverage", "Serving Clayton, Smithfield, Raleigh"], badge: null, status: "live", route: "/cities/garner" },
  { name: "Gastonia", tagline: "Gaston County expedited passport services", highlights: ["Gastonia area coverage", "Serving Belmont, Mount Holly"], badge: null, status: "live", route: "/cities/gastonia" },
  { name: "Goldsboro", tagline: "Wayne County expedited passport processing", highlights: ["Goldsboro area coverage", "Serving Seymour Johnson AFB, Mount Olive"], badge: null, status: "live", route: "/cities/goldsboro" },
  { name: "Greensboro", tagline: "Guilford County expedited passport hub", highlights: ["Piedmont Triad coverage", "Serving High Point, Winston-Salem"], badge: null, status: "live", route: "/cities/greensboro" },
  { name: "Greenville", tagline: "Pitt County expedited passport services", highlights: ["ECU area coverage", "Serving Winterville, Farmville"], badge: null, status: "live", route: "/cities/greenville" },
  { name: "Harrisburg", tagline: "Cabarrus County expedited passport processing", highlights: ["Harrisburg area coverage", "Serving Concord, Charlotte metro"], badge: null, status: "live", route: "/cities/harrisburg" },
  { name: "Hendersonville", tagline: "Henderson County expedited passport services", highlights: ["Hendersonville area coverage", "Serving Flat Rock, Fletcher"], badge: null, status: "live", route: "/cities/hendersonville" },
  { name: "Hickory", tagline: "Catawba County expedited passport processing", highlights: ["Hickory area coverage", "Serving Newton, Conover"], badge: null, status: "live", route: "/cities/hickory" },
  { name: "High Point", tagline: "Guilford & Davidson County expedited passport services", highlights: ["High Point area coverage", "Serving Thomasville, Archdale"], badge: null, status: "live", route: "/cities/high-point" },
  { name: "Holly Springs", tagline: "Wake County expedited passport processing", highlights: ["Holly Springs area coverage", "Serving Fuquay-Varina, Apex"], badge: null, status: "live", route: "/cities/holly-springs" },
  { name: "Huntersville", tagline: "Mecklenburg County expedited passport services", highlights: ["Huntersville area coverage", "Serving Cornelius, Davidson"], badge: null, status: "live", route: "/cities/huntersville" },
  { name: "Indian Trail", tagline: "Union County expedited passport processing", highlights: ["Indian Trail area coverage", "Serving Matthews, Stallings, Monroe"], badge: null, status: "live", route: "/cities/indian-trail" },
  { name: "Jacksonville", tagline: "Onslow County expedited passport services", highlights: ["Camp Lejeune & MCAS New River area", "Serving Richlands, Holly Ridge"], badge: null, status: "live", route: "/cities/jacksonville-nc" },
  { name: "Kannapolis", tagline: "Cabarrus & Rowan County expedited passport processing", highlights: ["Kannapolis area coverage", "Serving Concord, Salisbury"], badge: null, status: "live", route: "/cities/kannapolis" },
  { name: "Kernersville", tagline: "Forsyth County expedited passport services", highlights: ["Kernersville area coverage", "Serving Winston-Salem, Greensboro"], badge: null, status: "live", route: "/cities/kernersville" },
  { name: "Leland", tagline: "Brunswick County expedited passport processing", highlights: ["Leland area coverage", "Serving Wilmington, Hampstead, Southport"], badge: null, status: "live", route: "/cities/leland" },
  { name: "Matthews", tagline: "Mecklenburg County expedited passport services", highlights: ["Matthews area coverage", "Serving Mint Hill, Indian Trail"], badge: null, status: "live", route: "/cities/matthews" },
  { name: "Mooresville", tagline: "Iredell County expedited passport processing", highlights: ["Lake Norman area coverage", "Serving Davidson, Cornelius, Huntersville"], badge: null, status: "live", route: "/cities/mooresville" },
  { name: "Morrisville", tagline: "Wake County expedited passport services", highlights: ["RDU Airport area coverage", "Serving Cary, Durham, Research Triangle"], badge: null, status: "live", route: "/cities/morrisville" },
  { name: "New Bern", tagline: "Craven County expedited passport processing", highlights: ["New Bern area coverage", "Serving Havelock, James City"], badge: null, status: "live", route: "/cities/new-bern" },
  { name: "Raleigh", tagline: "Wake County emergency passport services", highlights: ["Downtown & North Hills coverage", "Serving Durham, Cary, Chapel Hill"], badge: "Most Popular", status: "live", route: "/cities/raleigh" },
  { name: "Rocky Mount", tagline: "Nash & Edgecombe County expedited passport services", highlights: ["Rocky Mount area coverage", "Serving Nashville, Wilson"], badge: null, status: "live", route: "/cities/rocky-mount" },
  { name: "Salisbury", tagline: "Rowan County expedited passport processing", highlights: ["Salisbury area coverage", "Serving Kannapolis, China Grove"], badge: null, status: "live", route: "/cities/salisbury" },
  { name: "Sanford", tagline: "Lee County expedited passport services", highlights: ["Sanford area coverage", "Serving Southern Pines, Pittsboro"], badge: null, status: "live", route: "/cities/sanford" },
  { name: "Statesville", tagline: "Iredell County expedited passport processing", highlights: ["Statesville area coverage", "Serving Mooresville, Troutman"], badge: null, status: "live", route: "/cities/statesville" },
  { name: "Thomasville", tagline: "Davidson County expedited passport services", highlights: ["Thomasville area coverage", "Serving Lexington, High Point"], badge: null, status: "live", route: "/cities/thomasville" },
  { name: "Wake Forest", tagline: "Wake & Franklin County expedited passport processing", highlights: ["Wake Forest area coverage", "Serving Rolesville, Youngsville"], badge: null, status: "live", route: "/cities/wake-forest" },
  { name: "Wilmington", tagline: "New Hanover County expedited passport hub", highlights: ["Wilmington & Wrightsville Beach coverage", "Serving Leland, Carolina Beach"], badge: null, status: "live", route: "/cities/wilmington" },
  { name: "Wilson", tagline: "Wilson County expedited passport services", highlights: ["Wilson area coverage", "Serving Rocky Mount, Nashville"], badge: null, status: "live", route: "/cities/wilson" },
  { name: "Winston-Salem", tagline: "Forsyth County expedited passport hub", highlights: ["Winston-Salem area coverage", "Serving Kernersville, Clemmons, Lewisville"], badge: null, status: "live", route: "/cities/winston-salem" },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function NCCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            North Carolina Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your North Carolina Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">North Carolina</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We are always adding new North Carolina locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}